import isBlank from 'is-blank'
import get from 'just-safe-get'
import jwtDecode from 'jwt-decode'
import Cookie from 'js-cookie'

import { foldazApi } from 'api'
import {
  SET_AUTH_TOKEN,
  CLEAR_AUTH_TOKEN,
  SET_CURRENT_USER,
  CLEAR_CURRENT_USER
} from './types'

const AUTH_TOKEN_KEY = 'authToken'
const CURRENT_USER_KEY = 'currentUser'

export const state = {
  authToken: null,
  currentUser: null
}

export const mutations = {
  [SET_AUTH_TOKEN] (state, authToken) {
    state.authToken = authToken
  },
  [CLEAR_AUTH_TOKEN] (state) {
    state.authToken = null
  },
  [SET_CURRENT_USER] (state, user) {
    state.currentUser = user
  },
  [CLEAR_CURRENT_USER] (state) {
    state.currentUser = null
  }
}

export const actions = {
  setAuthToken ({ commit, dispatch }, authToken) {
    commit(SET_AUTH_TOKEN, authToken)
    Cookie.set(AUTH_TOKEN_KEY, authToken)
    dispatch('fetchCurrentUser')
  },
  fetchCurrentUser ({ commit, state, dispatch }) {
    const { sub } = jwtDecode(state.authToken)
    return foldazApi.get(`/users/${sub}`)
      .then(({ data }) => {
        const obj = {
          ...get(data, 'user')
        }
        commit(SET_CURRENT_USER, obj)
        window.localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(obj))

        // set client
        dispatch('applyClient', get(obj, 'client'))
      })
  },
  restoreCurrentUser ({ commit, dispatch }) {
    const authToken = Cookie.get(AUTH_TOKEN_KEY)
    if (authToken) {
      commit(SET_AUTH_TOKEN, authToken)
      const currentUserString = window.localStorage.getItem(CURRENT_USER_KEY)
      if (currentUserString) {
        const currentUser = JSON.parse(currentUserString)
        commit(SET_CURRENT_USER, currentUser)

        // set client
        dispatch('applyClient', get(currentUser, 'client'))
      }
    } else {
      window.localStorage.removeItem(CURRENT_USER_KEY)
    }
  },
  clearAuthToken ({ commit }) {
    commit(CLEAR_AUTH_TOKEN)
    Cookie.remove(AUTH_TOKEN_KEY)
  },
  clearCurrentUser ({ commit }) {
    commit(CLEAR_CURRENT_USER)
    window.localStorage.removeItem(CURRENT_USER_KEY)
  },
  signOut ({ commit, dispatch }) {
    dispatch('clientTheme/reset')
    dispatch('clearAuthToken')
    dispatch('clearCurrentUser')
  }
}

export const getters = {
  isSignedIn ({ authToken, currentUser }) {
    return !isBlank(authToken) && !isBlank(currentUser)
  },
  currentUserId ({ currentUser }) {
    return currentUser && currentUser.id
  },
  currentClient ({ currentUser }) {
    return currentUser && currentUser.client
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/currentUser.js